/*
 * -----------------------------------------------------------------------
 *  <copyright file="programs-grid.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { orderBy } from '@progress/kendo-data-query';
import React, { useEffect, useState } from 'react';
import { useGridCells, useTranslation } from 'hooks';
import { restructuredUpdatedCreatedBy } from '@utils-clean/update-users-array';
import ExpandableGrid from 'views/components/core/expandable/grid';

import './styles.scss';

const ProgramsGrid = ({ programs, rowActions }: any) => {
    const { t } = useTranslation();
    const { MaxLengthCell, DateCell } = useGridCells();
    const newData = restructuredUpdatedCreatedBy(programs);
    const programsData = orderBy(newData, [{ field: 'name', dir: 'asc' }]);

    return (
        <ExpandableGrid
            customKey="programs-grid"
            id="programs"
            rowActions={rowActions}
            groupable={false}
            showPager
            scrollable="scrollable"
            reorderable
            pageable={false}
            addScroll
            resizable
            options={{
                allowExcelExport: false,
                allowExpandCollapseAll: false,
                useFilterChips: false,
            }}
            items={programsData}
            columns={[
                {
                    label: t('admin:program'),
                    field: 'name',
                    id: 'program-name',
                    minWidth: 180,
                    lockedByDefault: true,
                    cells: { data: MaxLengthCell(70) },
                },
                {
                    label: t('common:Products'),
                    field: 'productsLabel',
                    id: 'program-products',
                    minWidth: 180,
                    cells: { data: MaxLengthCell(150) },
                },
                {
                    label: t('common:Indications'),
                    field: 'indicationsLabel',
                    id: 'program-indications',
                    minWidth: 180,
                    cells: { data: MaxLengthCell(150) },
                },
                {
                    label: t('ra:createdDate'),
                    id: 'program-created',
                    minWidth: 180,
                    field: 'created',
                    cells: { data: DateCell },
                    filter: 'date',
                },
                {
                    label: t('ra:createdBy'),
                    id: 'program-createdby',
                    field: '_createdByString',
                    minWidth: 180,
                },
                {
                    label: t('ra:updatedDate'),
                    field: 'updated',
                    id: 'program-updated',
                    minWidth: 180,
                    filter: 'date',
                    cells: { data: DateCell },
                },
                {
                    label: t('ra:updatedBy'),
                    id: 'program-updatedby',
                    field: '_updatedByString',
                    minWidth: 180,
                },
                {
                    field: 'recordId',
                    label: t('id'),
                    id: 'program-id',
                    filter: 'numeric',
                    minWidth: 100,
                    showByDefault: false,
                },
            ]}
        />
    );
};

export default ProgramsGrid;
